import type { ReactNode } from 'react'

import { article as articleUi } from '@/shared/lib/articleStyles'

type ArticleCoverHeroProps = {
    category: string
    title: string
    dek: ReactNode
    imageSrc: string
    imageAlt: string
    byline: ReactNode
    imageClassName?: string
}

function categoryPills(category: string) {
    return category
        .split(/\s*[·|]\s*/)
        .map(part => part.trim())
        .filter(Boolean)
}

/** Overlay hero: photo background + dark scrim + title/dek (same idea as listing lead). */
export function ArticleCoverHero({
    category,
    title,
    dek,
    imageSrc,
    imageAlt,
    byline,
    imageClassName = 'absolute inset-0 h-full w-full object-cover',
}: ArticleCoverHeroProps) {
    const pills = categoryPills(category)

    return (
        <header className={articleUi.hero}>
            <div className={articleUi.cover}>
                <img
                    src={imageSrc}
                    alt={imageAlt}
                    className={imageClassName}
                    width={1536}
                    height={1024}
                    loading='eager'
                    fetchPriority='high'
                    decoding='async'
                />
                <div className={articleUi.coverScrimBase} aria-hidden />
                <div className={articleUi.coverScrim} aria-hidden />
                <div className={articleUi.coverContent}>
                    {pills.length > 0 ? (
                        <div className={articleUi.coverPills}>
                            {pills.map((pill, index) => (
                                <span
                                    key={pill}
                                    className={index === 0 ? articleUi.coverPillSolid : articleUi.coverPillOutline}
                                >
                                    {pill}
                                </span>
                            ))}
                        </div>
                    ) : null}
                    <h1 className={articleUi.coverTitle}>{title}</h1>
                    <div className={articleUi.coverDek}>{dek}</div>
                </div>
            </div>
            {byline}
        </header>
    )
}
